import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import {
  AuthService,
  ChatService,
  MemberService,
  MenuDataService,
  SignalRService,
} from 'shared';
import { RouterOutlet } from '@angular/router';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
  private PrimeNG = inject(PrimeNG);
  private menuDataService = inject(MenuDataService);
  private memberService = inject(MemberService);
  private authService = inject(AuthService);
  private chatService = inject(ChatService);
  private signalRService = inject(SignalRService);

  model: any = [
    {
      label: '',
      icon: 'pi pi-fw pi-sitemap',
      items: [
        {
          label: 'Πίνακας Ελέγχου',
          icon: 'pi pi-fw pi-home',
          routerLink: [''],
        },
        {
          label: 'Το Ημερολόγιο μου',
          icon: 'pi pi-fw pi-calendar',
          routerLink: ['/calendar'],
        },
        {
          label: 'Βάση Ασθενών',
          icon: 'pi pi-fw pi-users',
          routerLink: ['/manage-patients'],
        },
        {
          label: 'Συνταγογράφηση',
          icon: 'pi pi-fw pi-heart',
          routerLink: ['/prescriptions'],
        },

        // {
        //   label: 'Σύνθεση Ιατρείου',
        //   icon: 'pi pi-fw pi-warehouse',
        //   routerLink: ['***'],
        // },
      ],
    },
  ];

  ngOnInit(): void {
    this.PrimeNG.ripple.set(true);
    this.menuDataService.update(this.model);
    this.memberService.appName = 'doctor';
    const token = JSON.parse(localStorage.getItem('token')!);
    if (token) {
      this.signalRService.startConnection(token.token);
      this.authService.fetchUser(token).subscribe({
        next: () => {
          this.chatService.createCurrentSession();
        },
        error: () => {
          this.authService.logout();
        },
      });
    }
  }
  ngOnDestroy(): void {
    this.signalRService.destroyConnection();
  }
}
